import { ErrorBoundary } from '@highlight-run/next/client'
import { PropsWithChildren } from 'react'

import { AppError } from './AppError'

export function DSErrorBoundary({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary
      fallback={
        <AppError
          errorCode="app_error"
          errorDescription="We've been notified. Thanks for your patience 🙏"
          goHome={() => {
            // router.push will not work here due to behavior of error boundary
            window.location.replace('/')
          }}
        />
      }
      showDialog={false}
    >
      {children}
    </ErrorBoundary>
  )
}
